import { Flex } from '@valwin/facto/components';
import { ValwinFactoLoading } from '@valwin/facto/legacy';

export function Loading() {
  return (
    <Flex justify="center" align="center" minHeight="100dvh">
      <ValwinFactoLoading size={50} className="valwinFactoLoading--green" />
    </Flex>
  );
}
